import SellerFormContainer from './SellerFormContainer';

export default SellerFormContainer;
